require('./contractEasyLoanTypeCView.scss');

const PropTypes = require('prop-types');

//@vendors
const React = require('react');
const { connect } = require('react-redux');
const { withRouter } = require("react-router-dom");
//@actions
const blockedAccountsActions = require('actions/blockedAccounts');
const contractEasyLoanTypeC = require('../../actions/contractEasyLoanTypeC');
const contractInit = require('../../actions/commons/contractInit');
const contractEasyLoan = require('../../actions/contractEasyLoan');
const segmentedLoanActions = require('../../actions/segmentedLoanProducts');
const { getLoanRecordStatus, cancelLoanRecord } = require('../../actions/loanRecordStatus');
const printerActions = require("actions/contactCenter/printer");


//@commons
const { LoadingSection } = require('commonsComponents/loadingSection');
const { OKCover } = require('commonsComponents/OKCover');
const { OKHeaderSubPage } = require('commonsComponents/OKHeaderSubPage');
const PreLeaveModalComponent = require('components/preLeaveModalComponent/preLeaveModalComponent');
const { CallMeBack } = require('components/callMeBack/callMeBack');
//@core
const { formatText, getFinalTitle } = require('core/i18n').i18n;
//@components
const ContractEasyLoanApprovedTypeC = require('../../components/contracts/contractEasyLoanApprovedTypeC/contractEasyLoanApprovedTypeC');
const ContractEasyLoanTypeCErrorStep = require('../../components/contracts/contractEasyLoanApprovedTypeC/contractEasyLoanTypeCErrorStep/contractEasyLoanTypeCErrorStep');
const ContractEasyLoanErrorAsnef = require('../../components/contracts/contractAsnefError/contractAsnefError');
const ContractEasyLoanTypeCSuccessStep = require('../../components/contracts/contractEasyLoanApprovedTypeC/contractEasyLoanTypeCSuccessStep/contractEasyLoanTypeCSuccessStep');
const ContractEasyLoanTypeCSummary = require('../../components/contracts/contractEasyLoanApprovedTypeC/contractEasyLoanTypeCSummary/contractEasyLoanTypeCSummary');
const ContractLoanTooltip = require('../../components/contracts/contractLoanTooltip/contractLoanTooltip');
// @ CC Components
const profileActions = require('actions/profile');
const preContractualMailInfoActions = require('actions/preContractualMailInfo');

//@utilities
const { scrollToTop } = require('commonsUtilities/scrollUtils');
const { recordLinkV2 } = require("utilities/tagging");
const {
    EASY_LOAN_WAFFER
} = require('constants/flagBasedFeatures');
const { catalogue, analyticsId } = require('../../components/contracts/contractAresLoan/analytics/contractAresLoanAnalytics');
const {
    recordEasyLoanCApprovedAccountClose,
    recordEasyLoanCApprovedWizardNext,
    recordEasyLoanCApprovedAccountSelection,
    recordEasyLoanCApprovedCancelRecord
} = require('../../components/contracts/contractEasyLoanApprovedTypeC/analytics/contractEasyLoanApprovedTypeC.tracking');
const {
    easyLoanRecordStatus: { requestStatus: { PRE_APPROVAL_KO } },
    CONTRACT_EASY_LOAN_CATEGORY_EVENT
} = require('../../loansConstants/index');

class ContractEasyLoanApprovedTypeCView extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            displayLeaveModal: false
        };

        this.handleConfirmLeave = this.handleConfirmLeave.bind(this);
        this.onHandleSelectedAccount = this.onHandleSelectedAccount.bind(this);
        this.validateStepLoansAndMorgages = this.validateStepLoansAndMorgages.bind(this);
        this.leaveModalIsReady = this.leaveModalIsReady.bind(this);
        this.clearErrorsFile = this.clearErrorsFile.bind(this);
        this.setNameFile = this.setNameFile.bind(this);
        this.setVisibleStep = this.setVisibleStep.bind(this);
        this.loadFileInUpload = this.loadFileInUpload.bind(this);
        this.removeUploadedFile = this.removeUploadedFile.bind(this);
        this.goToGlobalPosition = this.goToGlobalPosition.bind(this);

    }

    componentDidMount() {
        const { immFlagBasedFeatures } = this.props;
        if (!immFlagBasedFeatures.get(EASY_LOAN_WAFFER)) {
            window.location.href = "/myprofile/loans-mortgages/";
        }
        // Position in the top of page after load
        scrollToTop();
        this.props.getInstallmentApprove();
    }

    componentDidUpdate() {
        if (this.props.immContractEasyLoanTypeC.get('notAvailable')) {
            this.props.history.push('/myprofile/loans-mortgages');
        }
    }

    componentWillUnmount() {
        const { resetBlockedAccounts } = this.props;
        this.setState({
            displayLeaveModal: true
        });
        this.props.onLeave();
        this.props.onLeaveInit();
        this.props.segmentedLoanProductsReset();
        resetBlockedAccounts();
    }

    loadFileInUpload(uploadName, file, idx) {
        const receiptDefaultName = formatText("payrollLoanRequestStepThree-payrollLoanRequestStepThree_receiptDefaultName");
        const messageSnackSuccess = formatText('payrollLoanRequestStepThree-payrollLoanRequestStepThree_uploadFileSuccess');
        const response = { uploadName, file, idx, receiptDefaultName, messageSnackSuccess };
        this.props.loadFileInUpload({ response });
    }

    clearErrorsFile(uploadName, idx, documentId) {
        this.props.clearErrorsFile({ uploadName, idx, documentId });
    }

    removeUploadedFile(uploadName, idx, documentId) {
        this.props.removeUploadedFile({ uploadName, idx, documentId });
    }

    setVisibleStep(visibleStep) {
        this.props.setVisibleStep({ visibleStep });
    }

    setNameFile(typeFile, nameFile, idx, documentId) {
        const receiptDefaultName = formatText("payrollLoanRequestStepThree-payrollLoanRequestStepThree_receiptDefaultName");
        const response = { typeFile, nameFile, idx, documentId, receiptDefaultName };
        this.props.handlerEditFileName({ response });
    }

    onHandleSelectedAccount(accountId, isCalledonMount = false, notSetAccountInDidUpdate = false) {
        const { setSelectedAccount, immAccounts } = this.props;
        const { byOrder: accounts = [] } =  immAccounts.toJS();
        if (!isCalledonMount) {
            recordEasyLoanCApprovedAccountSelection()
            recordEasyLoanCApprovedAccountClose()
        }
        (!notSetAccountInDidUpdate || accounts.length === 1) && setSelectedAccount({ accountId });
    }

    buildTaeTooltip() {
        const { immContractEasyLoanTypeC } = this.props;

        return (
            <ContractLoanTooltip
                immContractLoan={immContractEasyLoanTypeC}
                clarifyingText="clarifyingText"
            />
        );
    }
    buildSidebar() {
        const {
            immAccounts,
            immFlagBasedFeatures,
            immPayrollLoan,
            location,
            immContractEasyLoanTypeC
        } = this.props;
        const isNewOffer = immPayrollLoan.get('showNewOfferView');
        const selectedAccount = immContractEasyLoanTypeC.get('selectedAccount');
        const selectedAccountIsNotEmpty = selectedAccount !== ''
        const immAccount = selectedAccountIsNotEmpty && immAccounts.getIn(['byId', selectedAccount]);
        const alias = immAccount && immAccount.get('alias');
        const iban = immAccount && immAccount.get('iban');
        const balance = immAccount && immAccount.get('balance');
        const isCollective = immPayrollLoan.get('isCollective');
        const isDragoFeature = immFlagBasedFeatures.get(immPayrollLoan);
        let nodataNewOffer = undefined;
        let callKOxDTI = undefined;
        let taeTooltip = undefined;

        if (isNewOffer) {
            nodataNewOffer = !immPayrollLoan.getIn(['newOffer', 'seletedAmountOrTerm']);
            callKOxDTI = true;
        }

        return (
            <>
                <ContractEasyLoanTypeCSummary
                    alias={alias}
                    iban={iban}
                    balance={balance}
                    immAccount={immAccount}
                    selectedAccount={selectedAccount}
                    immStep={immPayrollLoan}
                    taeTooltip={taeTooltip}
                    nodataKOxDTI={nodataNewOffer}
                    callKOxDTI={callKOxDTI}
                    isCollective={isCollective}
                    location={location}
                    isDragoFeature={isDragoFeature}
                    immContractEasyLoanTypeC={immContractEasyLoanTypeC}
                />
            </>
        );
    }

    validateStepLoansAndMorgages(step) {
        const { validateStepLoansAndMorgages } = this.props;
        recordEasyLoanCApprovedWizardNext();
        validateStepLoansAndMorgages({ step });
    }

    buildBreadcrum() {
        return [
            {
                text: formatText('breadcrumb-loansAndMortgages'),
                url: `/myprofile/loans-mortgages`,
                onLinkClick: () => recordLinkV2(catalogue[analyticsId.CLICK_BREADCRUMB_01]()),
            },
            {
                text: formatText('contractEasyLoanTypeC-breadcrumb')
            }
        ];
    }

    buildContent() {
        const {
            downloadINEDocument,
            downloadPreContractDocument,
            downloanEasyLoanContractDocument,
            formalize,
            getAsnefValidation,
            getBlockedAccounts,
            getHiringDocuments,
            getInstallment,
            immAccounts,
            immContractEasyLoanTypeC,
            immContractEasyLoanInit,
            immContractEasyLoan,
            immFlagBasedFeatures,
            immProfile,
            onDownloadDocument,
            onPrintDocument,
            preContractualMail,
            requestMinInstallmentQuantity,
            requestProfile,
            resetPrecontractualMail,
            resetStep,
            sendMail,
            setImportMaxMin,
            setLoanAmount,
            setLoanTerm,
            setPaymentDay,
            setPurpose,
            setUpStep,
            setWillCancel,
            toggleAgreeCheckbox,
            toggleTypecIneAgreeCheckbox,
            printIneDocumentStep2,
            sendEasyLoanSimpleEmail,
            setNewJobType,
            setEmploymentLevel,
            setContractType,
            setOutcome,
            loadFilesEasyLoan,
            resetUploadConfig,
            docsUploaded,
            setInitApiFlag,
            toggleINEAgreeCheckbox,
            officePrintReset,
            onAgreeReset,
            resetMailSent,
            sendEasyLoanSimpleEmailApproved,
            checkReadDocument,
            immPrinter,
            setDocumentPrinted,
            showPrintedAndSignedStatusRequired,
            cleanErrorMessage,
        } = this.props;

        const formHandlers = {
            handleJobTypeChange: setNewJobType,
            handleOutcomeChange: setOutcome,
            handleEmploymentLevelChange: setEmploymentLevel,
            handleContractTypeChange: setContractType,
        };

        const error = immContractEasyLoanTypeC.get('error');
        const errorInit = immContractEasyLoanInit.get('errorPolicy');
        const errorAsnef = immContractEasyLoanTypeC.get('errorAsnef');
        const success = immContractEasyLoanTypeC.get('submitSuccessful');
        let content;
        if (error || errorInit) {
            content = this.buildError();
        } else if (errorAsnef) {
            content = this.buildErrorAsnef(immContractEasyLoan);
        } else if (success) {
            content = this.buildSuccess(immContractEasyLoanTypeC);
        } else if (immContractEasyLoan.get('stepReady')) {
            content = (
                <div>
                    <PreLeaveModalComponent
                        acceptText={formatText('contractEasyLoanAndMortgagesTypeC-leaveModalQuit')}
                        cancelText={formatText('contractEasyLoanAndMortgagesTypeC-leaveModalContinueLater')}
                        confirmationMessage={formatText('contractEasyLoanAndMortgagesTypeC-leaveModalMessage')}
                        confirmationTitle={formatText('contractEasyLoanAndMortgagesTypeC-leaveModalTitle')}
                        isReady={this.leaveModalIsReady}
                        onContinueLater={this.onContinueLater}
                        onCancelRecord={this.onCancelRecord}
                        taggingCategoryEvent={CONTRACT_EASY_LOAN_CATEGORY_EVENT}
                    />
                    <div className="contract-easy-loan-typec-view__content-data col-xs-8">
                        <ContractEasyLoanApprovedTypeC
                            loadFileInUpload={this.loadFileInUpload}
                            removeUploadedFile={this.removeUploadedFile}
                            clearErrorsFile={this.clearErrorsFile}
                            handlerEditFileName={this.setNameFile}
                            loadFilesEasyLoan={loadFilesEasyLoan}
                            docsUploaded={docsUploaded}
                            resetUploadConfig={resetUploadConfig}
                            downloadINEDocument={downloadINEDocument}
                            downloadPreContractDocument={downloadPreContractDocument}
                            downloanEasyLoanContractDocument={downloanEasyLoanContractDocument}
                            getAsnefValidation={getAsnefValidation}
                            getBlockedAccounts={getBlockedAccounts}
                            getHiringDocuments={getHiringDocuments}
                            getInstallment={getInstallment}
                            immAccounts={immAccounts}
                            immContractEasyLoanTypeC={immContractEasyLoanTypeC}
                            immContractEasyLoanInit={immContractEasyLoanInit}
                            immContractEasyLoan={immContractEasyLoan}
                            immFlagBasedFeatures={immFlagBasedFeatures}
                            immProfile={immProfile}
                            onDownloadDocument={onDownloadDocument}
                            onFinish={formalize}
                            onPrintDocument={onPrintDocument}
                            preContractualMail={preContractualMail}
                            requestMinInstallmentQuantity={requestMinInstallmentQuantity}
                            requestProfile={requestProfile}
                            resetPrecontractualMail={resetPrecontractualMail}
                            resetStep={resetStep}
                            sendMail={sendMail}
                            setImportMaxMin={setImportMaxMin}
                            setLoanAmount={setLoanAmount}
                            setLoanTerm={setLoanTerm}
                            setPaymentDay={setPaymentDay}
                            setPurpose={setPurpose}
                            setSelectedAccount={this.onHandleSelectedAccount}
                            setUpStep={setUpStep}
                            setVisibleStep={this.setVisibleStep}
                            setWillCancel={setWillCancel}
                            toggleAgreeCheckbox={toggleAgreeCheckbox}
                            toggleTypecIneAgreeCheckbox={toggleTypecIneAgreeCheckbox}
                            printIneDocumentStep2={printIneDocumentStep2}
                            sendEasyLoanSimpleEmail={sendEasyLoanSimpleEmail}
                            sendEasyLoanSimpleEmailApproved={sendEasyLoanSimpleEmailApproved}
                            formHandlers={formHandlers}
                            setInitApiFlag={setInitApiFlag}
                            toggleINEAgreeCheckbox={toggleINEAgreeCheckbox}
                            onAgreeReset={onAgreeReset}
                            officePrintReset={officePrintReset}
                            validateStepLoansAndMorgages={this.validateStepLoansAndMorgages}
                            resetMailSent={resetMailSent}
                            checkReadDocument={checkReadDocument}
                            immPrinter={immPrinter}
                            setDocumentPrinted={setDocumentPrinted}
                            showPrintedAndSignedStatusRequired={showPrintedAndSignedStatusRequired}
                            cleanErrorMessage={cleanErrorMessage}
                        />
                    </div>
                    <div className="col-xs-4">
                        {this.buildSidebar()}
                        <CallMeBack />
                    </div>
                </div>
            );
        }
        else {
            content = <LoadingSection />;
        }

        return content;
    }

    buildError() {
        const { immGlobalVariables, immContractEasyLoanTypeC } = this.props;
        const phoneNumber = immGlobalVariables.getIn(['variables', 'parameters', 'telefono', 'cliente']);
        const loanStatus = immContractEasyLoanTypeC.getIn(['cirbeResponse', 'preApprovalStatus']);
        let heading, message;

        if (loanStatus === PRE_APPROVAL_KO) {
            heading = "contractEasyTypeCLoanError-koTitle";
            message = "contractEasyTypeCLoanError-koMessage";
        }
        else {
            heading = "contractEasyTypeCLoanError-okTitle";
            message = __CONTACT_CENTER__ ? "contractEasyTypeCLoanError-okCCMessage" : "contractEasyTypeCLoanError-okMessage";
        }
        return (
            <ContractEasyLoanTypeCErrorStep
                phoneNumber={phoneNumber}
                heading={heading}
                message={message}
                immContractEasyLoanTypeC={immContractEasyLoanTypeC}
            />
        );
    }

    buildErrorAsnef(immContractEasyLoanTypeC) {
        return (
            <ContractEasyLoanErrorAsnef
                errorValue={immContractEasyLoanTypeC.get('selectedAmount')}
                history={this.props.history}
            />
        );
    }

    buildSuccess(immContractEasyLoanTypeC) {
        return (
            <ContractEasyLoanTypeCSuccessStep
                immContractEasyLoanTypeC={immContractEasyLoanTypeC}
                goToGlobalPosition={this.goToGlobalPosition}
                success={true}
            />
        );
    }

    goToGlobalPosition() {
        this.props.history.push('/myprofile/global');
    }

    goToLoansPage() {
        this.props.history.push('/myprofile/loans-mortgages');
    }

    handleConfirmLeave() {
        this.props.onLeave();
    }

    onContinueLater = () => {
        this.props.history.push('/myprofile/loans-mortgages');
    }

    onCancelRecord = () => {
        const recordId = this.props.immPayrollLoanRecordStatus.get('recordId');
        const { cancelLoanRecord } = this.props;
        cancelLoanRecord(recordId);
        recordEasyLoanCApprovedCancelRecord();
        this.props.history.push('/myprofile/loans-mortgages');
    }

    leaveModalIsReady() {
        return false;
    }

    render() {
        const breadcrumb = this.buildBreadcrum();
        const title = formatText('contractEasyLoanTypeC-title');
        const content = this.buildContent();

        return (
            <article className="contract-easy-loan-typec-view">
                <OKCover size="medium" section="pg">
                    <OKHeaderSubPage
                        breadcrumbConfig={breadcrumb}
                        finalTitle={getFinalTitle(title)} />
                </OKCover>
                <section className="contract-easy-loan-typec-view__body">
                    {content}
                </section>
            </article>
        );
    }
}

ContractEasyLoanApprovedTypeCView.propTypes = {
    downloadINEDocument: PropTypes.func.isRequired,
    downloadPreContractDocument: PropTypes.func.isRequired,
    downloanEasyLoanContractDocument: PropTypes.func.isRequired,
    formalize: PropTypes.func.isRequired,
    getAsnefValidation: PropTypes.func.isRequired,
    getBlockedAccounts: PropTypes.func.isRequired,
    getHiringDocuments: PropTypes.func.isRequired,
    getInstallment: PropTypes.func,
    getSegmentedLoanProducts: PropTypes.func.isRequired,
    immAccounts: PropTypes.object.isRequired,
    immContractEasyLoanTypeC: PropTypes.object.isRequired,
    immFlagBasedFeatures: PropTypes.object.isRequired,
    immGlobalVariables: PropTypes.object.isRequired,
    immProfile: PropTypes.object.isRequired,
    location: PropTypes.object,
    onDownloadDocument: PropTypes.func.isRequired,
    onLeave: PropTypes.func,
    onPrintDocument: PropTypes.func.isRequired,
    preContractualMail: PropTypes.object.isRequired,
    requestMinInstallmentQuantity: PropTypes.func.isRequired,
    requestProfile: PropTypes.func.isRequired,
    resetBlockedAccounts: PropTypes.func.isRequired,
    resetPrecontractualMail: PropTypes.func.isRequired,
    resetStep: PropTypes.func.isRequired,
    segmentedLoanProductsReset: PropTypes.func.isRequired,
    sendMail: PropTypes.func.isRequired,
    setEasyLoanAccountsInactive: PropTypes.func.isRequired,
    setImportMaxMin: PropTypes.func,
    setLoanAmount: PropTypes.func,
    setLoanTerm: PropTypes.func,
    setPaymentDay: PropTypes.func,
    setPurpose: PropTypes.func,
    setSelectedAccount: PropTypes.func.isRequired,
    setUpStep: PropTypes.func,
    setVisibleStep: PropTypes.func.isRequired,
    setWillCancel: PropTypes.func,
    toggleAgreeCheckbox: PropTypes.func.isRequired,
    toggleTypecIneAgreeCheckbox: PropTypes.func.isRequired,
    history: PropTypes.object.isRequired,
    getJobsInformation: PropTypes.func.isRequired,
    setEmploymentLevel: PropTypes.func.isRequired,
    setContractType: PropTypes.func.isRequired,
    getInstallmentRequest: PropTypes.func.isRequired,
    setNewJobType: PropTypes.func.isRequired,
    setOutcome: PropTypes.func.isRequired,
    loadFileInUpload: PropTypes.func.isRequired,
    removeUploadedFile: PropTypes.func.isRequired,
    clearErrorsFile: PropTypes.func.isRequired,
    resetUploadConfig: PropTypes.func.isRequired,
    handlerEditFileName: PropTypes.func.isRequired,
    loadFilesEasyLoan: PropTypes.func.isRequired,
    getLoanRecordStatus: PropTypes.func.isRequired,
    printIneDocumentStep2: PropTypes.func.isRequired,
    sendEasyLoanSimpleEmail: PropTypes.func.isRequired,
    docsUploaded: PropTypes.object.isRequired,
    cancelLoanRecord: PropTypes.func.isRequired
};

ContractEasyLoanApprovedTypeCView.defaultProps = {
    immContractEasyLoanTypeC: PropTypes.object.isRequired,
    onLeave: () => { },
    setImportMaxMin: () => { },
    setWillCancel: () => { }
};

module.exports.constructor = ContractEasyLoanApprovedTypeCView;
module.exports = withRouter(connect(
    state => ({
        immAccounts: state.accounts,
        immContractEasyLoanTypeC: state.contractEasyLoanTypeC,
        immContractEasyLoanInit: state.contractInit,
        immContractEasyLoan: state.contractEasyLoan,
        immContractInit: state.contractInit,
        immFlagBasedFeatures: state.flagBasedFeatures,
        immGlobalVariables: state.globalVariables,
        immProfile: state.profile,
        preContractualMail: state.preContractualMail,
        immPayrollLoanRecordStatus: state.loanRecordStatus,
        immPayrollLoan: state.contractPayrollLoan,
        immPayrollLoanRequest: state.payrollLoanRequest,
        immPrinter: state.printer,

    }), {
    getLoanRecordStatus: getLoanRecordStatus,
    contractLoan: contractEasyLoanTypeC.contractLoan,
    downloadINEDocument: contractEasyLoanTypeC.downloadINEDocument,
    downloadPreContractDocument: contractEasyLoanTypeC.downloadPreContractDocument,
    downloanEasyLoanContractDocument: contractEasyLoanTypeC.downloanEasyLoanContractDocument,
    formalize: contractEasyLoanTypeC.formalizeApproved,
    setInitApiFlag: contractInit.setInitApiFlag,
    officePrintReset: contractEasyLoan.officePrintReset,
    validateStepLoansAndMorgages: contractEasyLoanTypeC.validateApproveStep,
    initialize: contractEasyLoanTypeC.initialize,
    setNewJobType: contractEasyLoanTypeC.setNewJobType,
    setEmploymentLevel: contractEasyLoanTypeC.setEmploymentLevel,
    setContractType: contractEasyLoanTypeC.setContractType,
    setOutcome: contractEasyLoanTypeC.setOutcome,
    getJobsInformation: contractEasyLoanTypeC.getJobsInformation,
    getInstallmentRequest: contractEasyLoanTypeC.getInstallmentRequest,
    getAsnefValidation: contractEasyLoanTypeC.getAsnefValidation,
    getBlockedAccounts: blockedAccountsActions.getBlockedAccounts,
    getHiringDocuments: contractEasyLoanTypeC.getHiringDocuments,
    getInstallment: contractEasyLoanTypeC.getInstallmentPreapproved,
    getInstallmentApprove: contractEasyLoanTypeC.getInstallmentApprove,
    getSegmentedLoanProducts: segmentedLoanActions.getSegmentedLoanProducts,
    onDownloadDocument: contractEasyLoanTypeC.onDownloadDocument,
    onLeave: contractEasyLoanTypeC.simpleActions.contractEasyLoanTypecWillLeave,
    onLeaveInit: contractInit.simpleActions.contractEasyLoanInitWillLeave,
    onPrintDocument: contractEasyLoanTypeC.onPrintDocument,
    requestMinInstallmentQuantity: contractEasyLoanTypeC.requestMinInstallmentQuantity,
    requestProfile: profileActions.requestProfile,
    resetBlockedAccounts: blockedAccountsActions.resetBlockedAccounts,
    resetPrecontractualMail: preContractualMailInfoActions.resetPrecontractualMail,
    resetStep: contractEasyLoanTypeC.simpleActions.contractEasyLoanTypecResetStep,
    segmentedLoanProductsReset: segmentedLoanActions.simpleActions.segmentedLoanProductsReset,
    sendMail: preContractualMailInfoActions.sendLoanPreContractualMail,
    setLoanAmount: contractEasyLoanTypeC.simpleActions.contractEasyLoanSetLoanAmount,
    setLoanTerm: contractEasyLoanTypeC.simpleActions.contractEasyLoanTypecSetTerm,
    setPaymentDay: contractEasyLoanTypeC.simpleActions.contractEasyLoanSetPaymentDay,
    setPurpose: contractEasyLoanTypeC.setPurpose,
    setSelectedAccount: contractEasyLoanTypeC.simpleActions.contractEasyLoanSetAccount,
    setUpStep: contractEasyLoanTypeC.setUpStep,
    setVisibleStep: contractEasyLoanTypeC.simpleActions.contractEasyLoanTypecSetStep,
    setWillCancel: contractEasyLoanTypeC.setWillCancel,
    toggleAgreeCheckbox: contractEasyLoanTypeC.simpleActions.contractEasyLoanTypecToggleAgreeCheckbox,
    loadFileInUpload: contractEasyLoanTypeC.uploadFilesForEasyLoan,
    removeUploadedFile: contractEasyLoanTypeC.removeFileForEasyLoan,
    clearErrorsFile: contractEasyLoanTypeC.clearErrors,
    resetUploadConfig: contractEasyLoanTypeC.simpleActions.easyLoanRequestUploadFileReset,
    handlerEditFileName: contractEasyLoanTypeC.editNameFilesForEasyLoan,
    loadFilesEasyLoan: contractEasyLoanTypeC.loadFilesEasyLoan,
    docsUploaded: contractEasyLoanTypeC.docsUploaded,
    toggleTypecIneAgreeCheckbox: contractEasyLoanTypeC.simpleActions.contractEasyLoanTypecIneToggleAgreeCheckbox,
    printIneDocumentStep2: contractEasyLoanTypeC.simpleActions.contractEasyLoanTypecPrintStep2,
    sendEasyLoanSimpleEmail: contractEasyLoanTypeC.sendEasyLoanSimpleEmail,
    sendEasyLoanSimpleEmailApproved: contractEasyLoanTypeC.sendEasyLoanSimpleEmailApproved,
    cancelLoanRecord: cancelLoanRecord,
    resetMailSent: contractEasyLoan.resetMailSent,
    checkReadDocument: contractEasyLoanTypeC.checkReadDocumentPolicy,
    setDocumentPrinted: printerActions.setDocumentPrinted,
    showPrintedAndSignedStatusRequired: printerActions.showPrintedAndSignedStatusRequired,
    cleanErrorMessage: printerActions.cleanErrorMessage,
}
)(ContractEasyLoanApprovedTypeCView));
